e4.p = {
    init: function () {
        e4.p.icon.init();
        e4.p.banner.init();
    }
};
